// extracted by mini-css-extract-plugin
export default {"collapsibleContent":"collapsibleContent"};